module.exports = __webpack_public_path__ + "img/search-by-zip-red.3f0da115.png";